export default __webpack_public_path__ + "static/media/ic_philippines.524d873a.svg";